const defaultValidator = () => null;

export default defaultValidator;
